// ROUTER
import Vue from "vue";
import VueRouter from "vue-router";

const Login = () => import("@/views/Login.vue");
const Logout = () => import("@/views/Logout.vue");
const Root = () => import("@/views/RootPage.vue");
const CampaignList = () => import("@/views/campaign/CampaignList.vue");
const CampaignDetail = () => import("@/views/campaign/CampaignDetail.vue");
const ManagerList = () => import("@/views/manager/ManagerList.vue");

Vue.use(VueRouter);

const router = new VueRouter({
  // mode: 'history',
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/login",
      component: Login
    },
    {
      path: "/logout",
      component: Logout
    },
    {
      path: "/",
      name: "CommonPage",
      component: Root,
      // beforeEnter(to, from, next) {
      //   next();
      // },
      children: [
        {
          path: "/campaigns",
          name: "CampaignList",
          component: CampaignList,
          alias: "/"
        },
        {
          path: "/campaign/:id(\\d+)",
          component: CampaignDetail,
          name: "CampaignDetail"
        },
        {
          path: "/users",
          component: ManagerList,
          name: "ManagerList"
        }
      ]
    }
  ]
});

export default router;
